<template>
    <div class="add-new-main-dialog">
        <el-dialog
            :visible="true"
            title="特权新增商机"
            width="1000px"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            @close="emit('handleClose', false)">
            <search-box
                ref="searchBox"
                :search-key="config.name"
                :fields="config.searchFields"
                :showResetBtn="true"
                @search-change="neoCrmOpportunityList.searchList"
            />
            <table-box
                class="add-main-dialog-table"
                v-loading="neoCrmOpportunityList.tableLoading"
                ref="tableBox"
                :selection="true"
                :height="config.height"
                :columns="config.columns"
                :rows="neoCrmOpportunityList.totalData"
                :highlight-current-row="detailPageState !== 'new'"
                @selection-change="handleSelectedChange"
                @row-click="handleRowClick"
            >
            </table-box>
            <lots-pagination
                @size-change="neoCrmOpportunityList.sizeChange"
                :current-page.sync="neoCrmOpportunityList.pageNo"
                @current-change="neoCrmOpportunityList.pageChange"
                layout="total, sizes, prev, pager, next, jumper"
                :total="neoCrmOpportunityList.pageTotal"
                :pageSize="neoCrmOpportunityList.pageSize"
            ></lots-pagination>
            <span slot="footer">
                <el-button type="primary" size="mini" @click="confirm">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, onMounted } from '@vue/composition-api';
import searchBox from '@/components/lots/searchBox';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { ListClass } from '@/modules/mdm/composition/dc/common/list/ListClass';
import { tableConfig } from './config.js';
import { opportunityInfoPageApi } from '@mdm/api/opportunityModules/opportunityList.js';
import { Message } from 'element-ui';
import store from '@/store';
import utils from '@/components/utils/common.js';
const { MAGIC_NUMBER } = utils;
export default {
    components: { searchBox, tableBox, lotsPagination },
    props: {
        detailData: {
            type: Object,
            default() {
                return {};
            }
        },
        detailPageState: {
            type: String,
            default() {
                return '';
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        const emit = setupContext.emit;
        class DataDetailClass extends ListClass {
            beforeGetList(condition) {
                condition.userCode = store.getters.user.userCode;
                neoCrmOpportunityList.pageSize.value = condition.pageSize || MAGIC_NUMBER.FIFTY;
                return condition;
            };
            afterGetList(res) {
                if (+res.code === 0) {
                    if (+res.code === 0) {
                        neoCrmOpportunityList.totalData.value = res.data.list;
                        neoCrmOpportunityList.pageTotal.value = res.data.totalCount;
                    }
                }
            }
        };
        const neoCrmOpportunityList = new DataDetailClass({
            Api: {
                listApi: opportunityInfoPageApi
            }
        });
        onMounted(() => {
            neoCrmOpportunityList.getList({
                pageSize: 50,
                userCode: store.getters.user.userCode
            });
        });
        const selectedRows = ref([]);
        const handleSelectedChange = (rows) => {
            selectedRows.value = rows;
        };
        const handleRowClick = (row) => {
            setupContext.refs.tableBox.$refs.elTable.toggleRowSelection(row);
        };
        const handleDbclick = (row) => {
            const data = {
                opportunityList: [row]
            };
            emit('confirm', data);
        };
        const confirm = () => {
            const data = { opportunityList: [] };
            selectedRows.value.length && (data.opportunityList = selectedRows.value.map((item) => {
                return { ...item, isPureWarehouse: '', id: undefined };
            }));
            if (data.opportunityList.length === 0) {
                return Message.warning('请至少关联一条中标商机');
            }
            emit('confirm', data);
        };
        return {
            emit,
            config,
            neoCrmOpportunityList,
            selectedRows,
            handleSelectedChange,
            handleRowClick,
            confirm,
            handleDbclick
        };
    }
};
</script>
<style lang="less">
.add-new-main-dialog {
    .add-main-form-box {
        width: 100%;
        padding: 0 40px 0 0;
        box-sizing: border-box;
        .el-select {
            width: 100%;
        }
    }
    .add-main-dialog-table {
        margin: 10px 0 5px 0;
    }
    .el-table__body tr.current-row>td {
        background-color: #0072ff24;
    }
}
</style>
